import { FaEraser, FaPlus, FaSearch } from "react-icons/fa";
import Button from "../../../../components/button/button";
import { Template } from "../../../../components/template/template";
import { Card } from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useRef, useState } from "react";
import { useAlarmQuestionListQuery } from "../components/use-alarm-list-query";
import { navigateHook } from "../../../../hooks/use-navigate";
import AgGridUtils from "../../../../utils/aggrid-utils";

export default function AlarmQuestion() {
    const navigate = navigateHook();

    const [question, setQuestion] = useState("");
    const [questionInput, setQuestionInput] = useState("");
    const { data, isLoading, isError } = useAlarmQuestionListQuery();

    const rows = data?.rows ?? [];

    const filteredRows = useMemo(() => {
        const q = (question || "").trim().toLowerCase();
        if (!q) return rows;
        return rows.filter(r => (r.question ?? "").toLowerCase().includes(q));
    }, [rows, question]);

    const columnDefs = useMemo(() => {
        const questionComparator = (valueA, valueB) => {
            const a = (valueA || "").toString().toUpperCase();
            const b = (valueB || "").toString().toUpperCase();

            return a.localeCompare(b, "pt-BR");
        };
        return [
            {
                headerName: "Pergunta",
                field: "question",
                sortable: true,
                sort: "asc",
                comparator: questionComparator,
                flex:2,
            },
            {
                headerName: "Obrigatória",
                field: "required",
                sortable: true,
                flex: 1,
                valueFormatter: (params) => {
                    const v = (params.value || "").toString().toLowerCase();
                    if (v === "sim") return "Sim";
                    if (v === "não") return "Não";
                    return "";
                },
            },
        ];
    }, []);

    const gridRef = useRef(null);
    const goFirstPage = () => gridRef.current?.api?.paginationGoToFirstPage();

    //func enter busca e esc limpa
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
        handleSearch();
        }
        if (event.key === "Escape") {
        handleClear();
        }
    };

    const handleSearch = () => {
        setQuestion(questionInput.trim());
        goFirstPage();
    };

    const handleClear = () => {
        setQuestion("");
        setQuestionInput("");
        goFirstPage();
    };

    const onCellClicked = ({ data, event }) => {
        if(!data?.id) return;

        const urlDev = `/alarm-question/form/${data.id}`;
        let isBlank = !!event.ctrlKey;

        navigate(urlDev, isBlank);
    };

    const newQuestion = () => {
        const urlDev = "/alarm-question/form";
        navigate(urlDev);
    };

    return(
        <>
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Perguntas de alarmes</Template.Title>
                <Button onClick={newQuestion}><FaPlus />Adicionar pergunta</Button>
            </Template.Header>
            <Template.Body className="space-y-2 flex flex-col">
                <Card>
                    <Card.Body>
                        <div className="flex gap-4 items-end">
                            <div className="flex-1">
                                <InputForm 
                                    id="question"
                                    label="Pergunta"
                                    value={questionInput}
                                    onChange={(e) => setQuestionInput(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="flex gap-2">
                                <Button 
                                    target="primary-outline"
                                    title="Limpar"
                                    onClick={handleClear}
                                >
                                    <FaEraser />
                                </Button>
                                <Button
                                    title="Buscar"
                                    onClick={handleSearch}
                                >
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={filteredRows}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                suppressCellFocus
                                animateRows={false}
                                onCellClicked={onCellClicked}
                                gridOptions={{ localeText: AgGridUtils.localization() }}
                                theme={AgGridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>    
        </>
    )
}